import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Router from 'next/router';
import isomorphicRedirect from './isomorphicRedirect';
export var errorCodeRedirect = function errorCodeRedirect(_ref) {
  var code = _ref.code,
      errorCodeRules = _ref.errorCodeRules,
      ctx = _ref.ctx;
  var currentPage;

  if (ctx) {
    currentPage = ctx.pathname;
  } else if (process.browser) {
    currentPage = Router.route;
  }

  if (currentPage) {
    var errorRulesForPage = errorCodeRules ? errorCodeRules[currentPage] : undefined;

    if (!errorRulesForPage) {
      return;
    }

    var currentErrorCode = errorRulesForPage[code];

    if (currentErrorCode) {
      isomorphicRedirect(_objectSpread(_objectSpread({}, currentErrorCode), {}, {
        ctx: ctx
      }));
    }
  }
};